module.exports = "<option value=\"{%- id %}\">{%- text %}</option>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/order/html/uomDropdownOption.html
// module id = 1373
// module chunks = 1